import { isNotNullOrUndefined } from '@tpa/core';
import moment from 'moment';
import { normalizeBirthDateGroup } from './date-only.utils';
import {
  EmpTabsFormModelV2024,
  MY_TEST_CARD,
  ServerAppModel,
  ServerHeoModel,
  VariantaNull,
  ZdravotniPojistovnaAStav,
  zServerAppModel,
  zServerHeoModel
} from './employee-2024.types';
import { Duchody2026, EmpTabsFormModelV2026, MY_TEST_CARD_2026, ServerAppModel2026, ServerHeoModel2026, VariantaNull_2026, ZdravotniPojistovnaAStav2026, zServerAppModel2026, zServerHeoModel2026, zZdravotniPojistovnaAStav2026 } from './employee-2026.types';

/**
 * from  FE to server
 */
export const mapToServerHeoModel2026 = (
  data: EmpTabsFormModelV2026
): ServerHeoModel2026 => {

  let datumExpirace = data.personalPart?.idcard?.datumExpirace;
  if (datumExpirace) datumExpirace = moment(datumExpirace).format('yyyy-MM-DD');

  let datumNastupu = data.taxDeclaration?.datumNastupu;
  if (datumNastupu) datumNastupu = moment(datumNastupu).format('yyyy-MM-DD');

  let datumUkonceni = data.taxDeclaration?.datumUkonceni;
  if (datumUkonceni) datumUkonceni = moment(datumUkonceni).format('yyyy-MM-DD');



  return JSON.parse(
    JSON.stringify({
      jmeno: data.personalPart?.personalInfo?.jmeno,
      prijmeni: data.personalPart?.personalInfo?.prijmeni,
      drivejsiPrijmeni: data.personalPart?.personalInfo?.drivejsiPrijmeni,
      statNarozeni: data.personalPart?.personalInfo?.statNarozeni,
      vydalOrgan: data.personalPart?.idcard?.vydalOrgan,
      email: data.personalPart?.personalInfo?.email,
      kontaktniAdresa: data.personalPart?.kontaktniAdresa || {},
      permanentniAdresa: data.personalPart?.permanentniAdresa || {},
      mamCeskouPrechodnouAdresu: data.personalPart?.mamCeskouPrechodnouAdresu ?? null,
      prechodnaAdresa: data.personalPart?.mamCeskouPrechodnouAdresu ? (
        data.personalPart?.prechodnaAdresa || {}) : {},
      titulpred: data.personalPart?.personalInfo?.titulpred,
      titulza: data.personalPart?.personalInfo?.titulza,
      rodnePrijmeni: data.personalPart?.personalInfo?.rodnePrijmeni,
      rodneCisloADatumNarozeni: normalizeBirthDateGroup(data.personalPart?.personalInfo?.rodneCisloADatumNarozeni),
      mistoNarozeni: data.personalPart?.personalInfo?.mistoNarozeni,
      rodinnyStav: data.personalPart?.personalInfo?.rodinnyStav,
      pohlavi: data.personalPart?.personalInfo?.pohlavi,
      vzdelani: data.personalPart?.personalInfo?.vzdelani,
      pocetVychDeti: data.personalPart?.personalInfo?.pocetVychDeti,
      statniPrislusnost: data.personalPart?.personalInfo?.statniPrislusnost,
      cisloUctu: data.personalPart?.wage?.cisloUctu,
      idUstavu: data.personalPart?.wage?.idUstavu,
      iban: data.personalPart?.wage?.iban,
      cisloDokladu: data.personalPart?.idcard?.cisloDokladu,
      datumExpirace: datumExpirace,
      chciProhlaseni:
        data.taxDeclaration?.taxDeclaration?.affidavit?.chciProhlaseni,
      datumNastupu: datumNastupu,
      datumUkonceni: datumUkonceni,
    })
  );
};

/**
 * from  FE to server
 */
export const mapToServerAppModel2026 = (
  data: EmpTabsFormModelV2026
): ServerAppModel2026 => {
  try {
    let obj: ServerAppModel2026 = {
      rezidentura:
        data.taxDeclaration?.rezidentura?.rezidentura?.toString() || undefined,
      rezidenturaVeState:
        (data.taxDeclaration?.rezidentura?.rezidentura?.toString() !== 'true' &&
          data.taxDeclaration?.rezidentura?.rezidenturaVeState) ||
        undefined,
      rezidenturaText:
        data.taxDeclaration?.rezidentura?.rezidenturaText || undefined,
      rezidenturaVyhodnoceni:
        data.taxDeclaration?.rezidentura?.rezidenturaVyhodnoceni || undefined,
      typDanoveIdentifikace:
        data.taxDeclaration?.rezidentura?.typDanoveIdentifikace || undefined,
      zdrzovaniVCR: data.taxDeclaration?.rezidentura?.zdrzovaniVCR,
      studiumVCR: data.taxDeclaration?.rezidentura?.studiumVCR,
      identifikace:
        (data.taxDeclaration?.rezidentura?.rezidentura?.toString() !== 'true' &&
          data.taxDeclaration?.rezidentura?.identifikace) ||
        undefined,

      doklad: data.personalPart?.idcard?.doklad || undefined,
      typDokladu: data.personalPart?.idcard?.typDokladu || undefined,
      vydalStat: data.personalPart?.idcard?.vydalStat || undefined,

      dalsiPracovniPomer:
        data.personalPart?.dalsiPracovniPomer?.dalsiPracovniPomer,
      nazevDalsihoZamestnavatele:
        data.personalPart?.dalsiPracovniPomer?.nazevDalsihoZamestnavatele,
      sidloDalsihoZamestnavatele:
        data.personalPart?.dalsiPracovniPomer?.sidloDalsihoZamestnavatele,

      exekuce: data.personalPart?.execution?.exekuce,
      // TODO proverit
      // jineProhlaseni: data.jineProhlaseni,

      salaryForm: data.personalPart?.wage?.salaryForm || undefined,

      // Schvaleno v notion, nyni posilat jen v karta casti
      // pohlavi: data.personalPart?.personalInfo?.pohlavi || undefined,
    };
    if (data.taxDeclaration?.taxDeclaration?.affidavit) {
      obj = {
        ...obj,
        prohlaseniKProhlaseni: data.taxDeclaration.taxDeclaration.affidavit
          ?.prohlaseniKProhlaseni
          ? data.taxDeclaration.taxDeclaration.affidavit.prohlaseniKProhlaseni
          : data.taxDeclaration.taxDeclaration.affidavit.chciProhlaseni ||
          false,
        soucasneNeuplatnuji: data.taxDeclaration.taxDeclaration
          .soucasneNeuplatnuji
          ? true
          : false,
      };
    }

    if (
      data.personalPart?.personalInfo?.druhaStatniPrislusnostCheck &&
      data.personalPart?.personalInfo?.druhaStatniPrislusnostCheck
    ) {
      obj = {
        ...obj,
        druhaStatniPrislusnost:
          data.personalPart?.personalInfo?.druhaStatniPrislusnost,
      };
    }

    if (data.personalPart?.health) {
      let duchody = data.personalPart?.health?.duchody;
      if (duchody?.pobiramDuchod === false) {
        duchody = {
          pobiramDuchod: false,
          starobni: { pobiran: false },
          invalidni: { pobiran: false },
          invalidniTretihoStupne: { pobiran: false },
          starobniZahranicni: { pobiran: false },
          invalidniZahranicni: { pobiran: false },
          invalidniZahranicniTretihoStupne: { pobiran: false },
          jiny: { pobiran: false },
        };
      }

      let zdravotniPojistovnaAStav: zZdravotniPojistovnaAStav2026 = {
        zdravPojistovna: data.personalPart?.health?.zdravPojistovna,
        // TODO: remove if not zdravPojistovna "jina"
        jinaZdravPojistovna: data.personalPart?.health?.jinaZdravPojistovna,
        cisloPojistence: data.personalPart?.health?.cisloPojistence,
        zpsZtpp: data.personalPart?.health?.zpsZtpp,
        ztpp: data.personalPart?.health?.ztpp,
        a1: data.personalPart?.health?.a1,
        duchody,
        zdravotniZnevyhodneni: data.personalPart?.health?.zdravotniZnevyhodneni,
        priznaneOd: data.personalPart?.health?.priznaneOd,
        priznaneDo: data.personalPart?.health?.priznaneDo,

      };



      obj = {
        ...obj,
        zdravotniPojistovnaAStav: zdravotniPojistovnaAStav,
      };
    }

    if (data.taxDeclaration?.taxDeclaration?.affidavit?.chciProhlaseni) {
      //Mesicni slevy
      const monthDiscount = data.taxDeclaration.taxDeclaration.monthDiscount;
      obj = {
        ...obj,
        zakladniSlevaNaPoplatnika:
          monthDiscount?.zakladniSlevaNaPoplatnika?.value,
        rozsirenaSlevaNaInvalidituMesice:
          monthDiscount?.rozsirenaSlevaNaInvalidituMesice?.value || 0,
        zakladniSlevaNaInvalidituMesice:
          monthDiscount?.zakladniSlevaNaInvalidituMesice?.value || 0,
        slevaNaDrziteleZTPPMesice:
          monthDiscount?.slevaNaDrziteleZTPPMesice?.value || 0,
        slevaNaStudentaMesice: monthDiscount?.slevaNaStudentaMesice?.value || 0,
      };

      const deti = data.taxDeclaration.taxDeclaration.children?.deti;
      const dalsiPoplatnik =
        data.taxDeclaration?.taxDeclaration?.partner?.dalsiPoplatnik;
      if (deti && deti.length > 0) {
        obj = {
          ...obj,
          // Each child carries the same birth-date group as the employee; without this the
          // zod `DateOnly` transform would turn a picker `Date` into a `Z` instant.
          deti: deti.map((dite) => ({
            ...dite,
            rodneCisloADatumNarozeni: normalizeBirthDateGroup(
              dite.rodneCisloADatumNarozeni
            ),
          })),
          dalsiPoplatnik: dalsiPoplatnik == null ? undefined : dalsiPoplatnik,
        };
        const partner = data.taxDeclaration?.taxDeclaration?.partner;


        if (partner && partner.dalsiPoplatnik == true) {



          obj = {
            ...obj,
            jmenoPoplatnika: partner.jmenoPoplatnika || undefined,
            prijmeniPoplatnika: partner.prijmeniPoplatnika || undefined,
            rodneCisloADatumNarozeniPoplatnika:
              normalizeBirthDateGroup(
                partner.rodneCisloADatumNarozeniPoplatnika
              ) || undefined,
            trvalyPobytPoplatnika: partner.trvalyPobytPoplatnika || undefined,
            uplatnujePoplatnik:
              partner.uplatnujePoplatnik === null
                ? undefined
                : partner.uplatnujePoplatnik,
            zamestnaniPoplatnika:
              partner.zamestnaniPoplatnika === null
                ? undefined
                : partner.zamestnaniPoplatnika,
            platceDanePoplatnika: partner.platceDanePoplatnika || undefined,
            adresaPlatceDanePoplatnika:
              partner.adresaPlatceDanePoplatnika || undefined,
          };
        }
      }
    }
    return zServerAppModel2026.parse(obj)
    //return JSON.parse(JSON.stringify(obj));
  } catch (e) {
    console.log(e)
  }
  // ! THIS IS VERY DANGEROUS!
  //return null;
};
/**
 * Server to FE
 */
export const mapToApp2026 = (
  karta?: ServerHeoModel2026 | undefined,
  app?: ServerAppModel2026 | undefined,
  dodatecneAtributy?: any,
  resetCausedByNewYear?: boolean,
): EmpTabsFormModelV2026 => {
  try {
    const helios = zServerHeoModel2026.parse(karta ? karta : mapToServerHeoModel2026(VariantaNull_2026));
    const portal = zServerAppModel2026.parse(app ? app : mapToServerAppModel2026(VariantaNull_2026));


    // check if rezidentura null, clear all data about rezidenci
    let rezidentura: string | boolean = (portal.rezidentura as
      | string
      | boolean
      | undefined)
      ? (portal.rezidentura as string | boolean)
      : false;
    //console.log(typeof rezidentura,typeof rezidentura === 'boolean')
    if (typeof rezidentura === 'boolean' && rezidentura == true) {
      rezidentura = 'true';
    }
    if (typeof rezidentura === 'boolean' && rezidentura == false) {
      rezidentura = 'false';
    }

    let rezidenturaVyhodnoceni = portal.rezidenturaVyhodnoceni || null;
    if (rezidenturaVyhodnoceni === 'konzultace') {
      // Remove rezidenci in 2026 if it is konzultace
      rezidentura = null;
      rezidenturaVyhodnoceni = null;
    }

    let rezidenturaData = {
      rezidentura: portal.rezidentura || null,
      rezidenturaVeState:
        (portal.rezidentura !== 'true' && portal.rezidenturaVeState) || null,
      rezidenturaText: portal.rezidenturaText || null,
      rezidenturaVyhodnoceni: rezidenturaVyhodnoceni,
      identifikace: portal.identifikace || null,
      zdrzovaniVCR:
        portal.zdrzovaniVCR !== undefined ? portal.zdrzovaniVCR : null,
      studiumVCR: portal.studiumVCR !== undefined ? portal.studiumVCR : null,
      typDanoveIdentifikace: portal.typDanoveIdentifikace || null,
    };
    // Only clear residency data when residency itself is unset (e.g. fresh
    // card or `konzultace` outcome that nullified `rezidentura` above).
    //
    // Previously this also cleared on `zdrzovaniVCR == null`, but the
    // manual-fallback flow (personal part locked + required personal data
    // missing) intentionally hides the zdrzovaniVCR question and lets the
    // user pick `rezidentura` directly. Keeping the old check would discard
    // the just-saved manual residency on every server roundtrip.
    if (rezidentura == null || rezidentura == undefined) {
      rezidenturaData = {
        rezidentura: null,
        rezidenturaVeState: null,
        rezidenturaText: null,
        rezidenturaVyhodnoceni: null,
        identifikace: portal.identifikace || null,
        zdrzovaniVCR: null,
        studiumVCR: null,
        typDanoveIdentifikace: null,
      };
    }

    // debugger;

    // const a = !isNotNullOrUndefined(portal.zakladniSlevaNaInvalidituMesice);
    // const b = isNotNullOrUndefined(portal.zakladniSlevaNaInvalidituMesice);
    // const c = a ? 'y' : 'n';
    // const d = b ? 'y' : 'n';

    // const zakladniSlevaNaInvalidituMesice = {
    //   value: !isNotNullOrUndefined(portal.zakladniSlevaNaInvalidituMesice)
    //     ? portal.zakladniSlevaNaInvalidituMesice
    //     : null,
    // };

    // console.log('original', helios.datumExpirace);
    // console.log('moment', moment(helios.datumExpirace, 'yyyy-MM-DD').toDate());







    const card: EmpTabsFormModelV2026 = {
      personalPart: {
        personalInfo: {
          jmeno: helios.jmeno || undefined,
          prijmeni: helios.prijmeni || undefined,
          email: helios.email || undefined,

          titulpred: helios.titulpred || undefined,
          titulza: helios.titulza || undefined,
          rodnePrijmeni: helios.rodnePrijmeni || undefined,
          rodneCisloADatumNarozeni: helios.rodneCisloADatumNarozeni || undefined,
          mistoNarozeni: helios.mistoNarozeni || undefined,
          rodinnyStav: helios.rodinnyStav || undefined,

          vzdelani: helios.vzdelani || undefined,
          pocetVychDeti: helios.pocetVychDeti,
          statniPrislusnost: helios.statniPrislusnost || undefined,
          druhaStatniPrislusnost: portal.druhaStatniPrislusnost || null,
          druhaStatniPrislusnostCheck: portal.druhaStatniPrislusnost
            ? true
            : false,

          pohlavi: helios.pohlavi || null,
          drivejsiPrijmeni: helios.drivejsiPrijmeni,
          statNarozeni: helios.statNarozeni,
        },

        // allowContactAddress?: ,
        // allowTemporaryAddress?: ,

        permanentniAdresa: helios.permanentniAdresa || undefined,
        kontaktniAdresa: helios.kontaktniAdresa || undefined,
        mamCeskouPrechodnouAdresu: helios.mamCeskouPrechodnouAdresu ?? null,
        prechodnaAdresa: helios.prechodnaAdresa || undefined,

        wage: {
          salaryForm: portal.salaryForm || null,
          cisloUctu: helios.cisloUctu || null,
          idUstavu: helios.idUstavu || null,
          iban: helios.iban || null,
        },
        health: duchodyJineEvaluation2026(portal.zdravotniPojistovnaAStav),
        idcard: {
          typDokladu: portal.typDokladu || null,
          vydalStat: portal.vydalStat || null,
          doklad: portal.doklad || null,
          cisloDokladu: helios.cisloDokladu || null,
          datumExpirace: helios.datumExpirace,
          vydalOrgan: helios.vydalOrgan || null,

        },
        execution: {
          exekuce: portal.exekuce || false,
        },
        dalsiPracovniPomer: {
          dalsiPracovniPomer: portal?.dalsiPracovniPomer || false,
          nazevDalsihoZamestnavatele: portal.nazevDalsihoZamestnavatele,
          sidloDalsihoZamestnavatele: portal.sidloDalsihoZamestnavatele,
        },
      },
      taxDeclaration: {
        rezidentura: {
          ...rezidenturaData,
          // rezidentura: portal.rezidentura || null,
          // rezidenturaVeState: portal.rezidenturaVeState || null,
          // rezidenturaText: portal.rezidenturaText || null,
          // rezidenturaVyhodnoceni: portal.rezidenturaVyhodnoceni || null,
          // identifikace: portal.identifikace || null,
          // zdrzovaniVCR:
          //   portal.zdrzovaniVCR !== undefined ? portal.zdrzovaniVCR : null,
          // studiumVCR: portal.studiumVCR !== undefined ? portal.studiumVCR : null,
        },
        taxDeclaration: {
          monthDiscount: {
            zakladniSlevaNaPoplatnika: {
              value: isNotNullOrUndefined(portal.zakladniSlevaNaPoplatnika)
                ? portal.zakladniSlevaNaPoplatnika
                : null,
            },
            rozsirenaSlevaNaInvalidituMesice: {
              value: isNotNullOrUndefined(
                portal.rozsirenaSlevaNaInvalidituMesice
              )
                ? portal.rozsirenaSlevaNaInvalidituMesice
                : null,
            },
            zakladniSlevaNaInvalidituMesice: {
              value: isNotNullOrUndefined(
                portal.zakladniSlevaNaInvalidituMesice
              )
                ? portal.zakladniSlevaNaInvalidituMesice
                : null,
            },
            slevaNaDrziteleZTPPMesice: {
              value: isNotNullOrUndefined(portal.slevaNaDrziteleZTPPMesice)
                ? portal.slevaNaDrziteleZTPPMesice
                : null,
            },
            slevaNaStudentaMesice: {
              value: isNotNullOrUndefined(portal.slevaNaStudentaMesice)
                ? portal.slevaNaStudentaMesice
                : null,
            },
          },
          children: {
            // TODO proverit
            // jineProhlaseni: portal.jineProhlaseni || null,
            deti: portal.deti || [],
          },

          affidavit: {
            prohlaseniKProhlaseni:
              portal.prohlaseniKProhlaseni != undefined
                ? portal.prohlaseniKProhlaseni
                : null,
            chciProhlaseni: helios.chciProhlaseni || false,
          },

          partner: {
            dalsiPoplatnik: portal.dalsiPoplatnik,

            jmenoPoplatnika: portal.jmenoPoplatnika || null,
            prijmeniPoplatnika: portal.prijmeniPoplatnika || null,
            rodneCisloADatumNarozeniPoplatnika: portal.rodneCisloADatumNarozeniPoplatnika,
            trvalyPobytPoplatnika: portal.trvalyPobytPoplatnika || null,
            uplatnujePoplatnik: portal.uplatnujePoplatnik,
            zamestnaniPoplatnika: portal.zamestnaniPoplatnika,
            platceDanePoplatnika: portal.platceDanePoplatnika || null,
            adresaPlatceDanePoplatnika: portal.adresaPlatceDanePoplatnika,
          },

          soucasneNeuplatnuji: portal.soucasneNeuplatnuji,
        },

        datumNastupu: helios.datumNastupu,
        datumUkonceni: helios.datumUkonceni,
      },
      pravdivostUdaju: false,
      dodatecneAtributy: {},
    };
    /// RESETOVANI pro novy rok
    if (resetCausedByNewYear) {
      if (card.taxDeclaration) {
        card.taxDeclaration.taxDeclaration.affidavit = {
          chciProhlaseni: null,
          prohlaseniKProhlaseni: null,
        };
        card.taxDeclaration.taxDeclaration.monthDiscount = {
          zakladniSlevaNaPoplatnika: {
            value: null,
          },
          rozsirenaSlevaNaInvalidituMesice: {
            value: null,
          },
          zakladniSlevaNaInvalidituMesice: {
            value: null,
          },
          slevaNaDrziteleZTPPMesice: {
            value: null,
          },
          slevaNaStudentaMesice: {
            value: null,
          },
        };
        if (card.taxDeclaration.taxDeclaration.children?.deti) {
          card.taxDeclaration.taxDeclaration.children.deti =
            card.taxDeclaration.taxDeclaration.children.deti.map((p) => ({
              ...p,
              uplatneni: [],
            }));
          if (card.taxDeclaration.taxDeclaration.partner) {
            card.taxDeclaration.taxDeclaration.partner.dalsiPoplatnik = null;
            card.taxDeclaration.taxDeclaration.partner.uplatnujePoplatnik =
              null;
            card.taxDeclaration.taxDeclaration.partner.zamestnaniPoplatnika =
              null;
          }
        }
      }
      // card.taxDeclaration.taxDeclaration.soucasneNeuplatnuji = null
    }

    return JSON.parse(JSON.stringify(card));
  } catch (e) {
    // ! THIS WAS VERY DANGEROUS!
    console.error(e);
  }
};

export const duchodyJineEvaluation2026 = (
  a: ZdravotniPojistovnaAStav2026 | undefined | null
): ZdravotniPojistovnaAStav2026 | undefined => {
  if (!a) return undefined;

  let zdravotniZnevyhodneni = a.zdravotniZnevyhodneni;

  // migration from 2024 to 2026 - firstorseconddegreeinvalidity is deprecated
  if (zdravotniZnevyhodneni == 'firstorseconddegreeinvalidity') {
    zdravotniZnevyhodneni = null
  }

  const health: ZdravotniPojistovnaAStav2026 = {
    a1: a.a1,
    zpsZtpp: a.zpsZtpp,
    cisloPojistence: a.cisloPojistence,
    ztpp: a.ztpp,
    jinaZdravPojistovna: a.jinaZdravPojistovna,
    zdravotniZnevyhodneni: zdravotniZnevyhodneni,
    zdravPojistovna: a.zdravPojistovna,
    priznaneOd: a.priznaneOd,
    priznaneDo: a.priznaneDo,
  };

  // Without `duchody` keep the rest of the health section rather than dropping
  // the whole block (a Helios snapshot can carry insurance data and no pensions).
  if (!a.duchody) return health;

  const evaulatePobiramDuchod = (value: ZdravotniPojistovnaAStav2026['duchody']) => {
    return value.invalidni?.pobiran || value.starobni?.pobiran || value.invalidniTretihoStupne?.pobiran || value.jiny?.pobiran || value.starobniZahranicni?.pobiran || value.invalidniZahranicni?.pobiran || value.invalidniZahranicniTretihoStupne?.pobiran;
  };

  return {
    ...health,
    duchody: {
      // Derive from the per-type flags as before; fall back to the stored value
      // only when they say nothing - Helios often sends just `pobiramDuchod`.
      pobiramDuchod: evaulatePobiramDuchod(a.duchody) ?? a.duchody.pobiramDuchod,
      starobni: a.duchody.starobni,
      invalidni: a.duchody.invalidni,
      invalidniTretihoStupne: a.duchody.invalidniTretihoStupne,
      starobniZahranicni: a.duchody.starobniZahranicni,
      invalidniZahranicni: a.duchody.invalidniZahranicni,
      invalidniZahranicniTretihoStupne: a.duchody.invalidniZahranicniTretihoStupne,
      jiny: a.duchody.jiny,
    }
  };
};

export const VALID_FORM_INIT_DATA_2026: EmpTabsFormModelV2026 = {
  pre: true,
  ...mapToApp2026(
    JSON.parse(JSON.stringify(MY_TEST_CARD_2026.karta)) as ServerHeoModel2026,
    JSON.parse(JSON.stringify(MY_TEST_CARD_2026.app)) as ServerAppModel2026,
    MY_TEST_CARD_2026.dodatecneAtributy
  ),
  // personalPart: {
  //   personalInfo: {
  //     jmeno: 'Michal',
  //     datumNarozeni: '1970-12-31T23:00:00Z',
  //   },
  //   wage: {},
  //   idcard: {
  //     doklad: {},
  //   },
  //   execution: { exekuce: false },
  //   dalsiPracovniPomer: {
  //     dalsiPracovniPomer: false,
  //     nazevDalsihoZamestnavatele: '',
  //     sidloDalsihoZamestnavatele: '',
  //   },
  // },
};

export const mapToApp2024To2026 = (data: EmpTabsFormModelV2024): EmpTabsFormModelV2026 => {

  // Rezidentura vyhodnoceni, zdravotni pojistovna a stav, duchody
  const duchody: Duchody2026 = {

  }

  if (data?.personalPart?.health?.duchody?.starobni) {
    duchody.starobni = {
      pobiran: true,
    }
    if (data?.personalPart?.health?.duchody?.predcasny) {
      duchody.starobni = {
        predcasnyStarobniDuchod: true,
      }
    }
  }

  if (data?.personalPart?.health?.duchody?.invalidni) {
    duchody.invalidni = {
      pobiran: true,
    }
  }
  if (data?.personalPart?.health?.duchody?.jiny) {
    duchody.jiny = {
      pobiran: true,
      // nazevDuchodu: data.personalPart.health.duchody.jiny.nazevDuchodu,
    }
  }

  return {
    ...data,
    personalPart: {
      ...data?.personalPart,
      health: {
        ...data?.personalPart?.health,
        duchody: {
          pobiramDuchod: data?.personalPart?.health?.duchody?.pobiramDuchod ? true : false,
          ...duchody,
        }
      }
    }
  }
}